import i18next from 'i18next'
import * as React from 'react'
import type { SupportedLanguage } from '../../../shared/i18n/i18n.no-deps'
import type { GetImage } from '../image/GetImage'

type TProps = {
    getImage: GetImage
    language: SupportedLanguage
    triggerSentryReplay: () => void
}

export class RenderErrorMessage extends React.Component<TProps, {}> {
    componentDidMount(): void {
        this.props.triggerSentryReplay()
    }

    public render() {
        return (
            <div className="AppCore__error__RenderErrorMessage">
                <img className="AppCore__error__RenderErrorMessage__image" src={this.props.getImage('ice-cream')} />
                <div className="AppCore__error__RenderErrorMessage__paragraph">
                    {i18next.getFixedT(this.props.language)('appcore:RenderErrorMessage.somethingWentWrong')}
                </div>
                <div className="AppCore__error__RenderErrorMessage__paragraph">
                    {i18next.getFixedT(this.props.language)('appcore:RenderErrorMessage.dontWorry')}
                </div>
                <div className="AppCore__error__RenderErrorMessage__suggestion">
                    {i18next.getFixedT(this.props.language)('appcore:RenderErrorMessage.keepsHappening')}
                    <a href="https://zaptic.zendesk.com/hc/en-gb" className="AppCore__error__RenderErrorMessage__link">
                        {i18next.getFixedT(this.props.language)('appcore:RenderErrorMessage.support')}
                    </a>
                </div>
            </div>
        )
    }
}
